import { defineStore } from 'pinia';
import axios from 'axios';

export const useUsersStore = defineStore('users', {
	state: () => ({
		users: [],
		user: null
	}),
	getters: {
		availableUsers: (state) => {
			const authStore = useAuthStore();
			const isSuperAdmin = authStore.access === 'super_admin';
			if (isSuperAdmin) {
				return state.users;
			}
			return state.users.filter(u => {
				const isUserSuper = u.roles_mask === 262144 || u.is_superuser;
				return !isUserSuper;
			});
		}
	},
	actions: {
		async fetchData(projectId) {
			const response = await axios.post('vuejs/get_recommendations_users', { projectId }, { withCredentials: true });
			this.users = response.data.data;
			this.users.forEach(item => {
				let itemName = item.first_name + ' ' + item.last_name;
				if (item.first_name == null && item.last_name == null) {
					const email = item.email;
					item.avatar = item.avatar ?? `https://ui-avatars.com/api/?name=${email}&background=random`;

				}
				else {
					item.avatar = item.avatar ?? `https://ui-avatars.com/api/?name=${item.first_name}+${item.last_name}&background=random`;
				}
			});
			return this.users;
		},
		async updateAssignedUser(taskId, userId, table = 'recommendations') {
			const response = await axios.post('vuejs/update_assigned_user', {
				task_id: taskId,
				user_id: userId,
				table: table
			});
			return response.data;
		},
		async updateDateTime(taskId, dateTime, table = 'recommendations') {
			const response = await axios.post('vuejs/update_date_time', {
				task_id: taskId,
				datetime: dateTime,
				table: table
			});
			return response.data;
		},
		async getUserById(user_id) {
			const response = await axios.get('vuejs/user/get_user_details_by_id', {
				params: {
					user_id: user_id
				},
				withCredentials: true
			});

			const userData = response.data.data;
			const user = {
				first_name: userData.first_name,
				last_name: userData.last_name,
				full_name: userData.first_name && userData.last_name ?
					`${userData.first_name} ${userData.last_name}` : null,
				email: userData.email,
				avatar: userData.avatar
			};

			if (!user.full_name) {
				user.avatar = user.avatar ?? `https://ui-avatars.com/api/?name=${user.email}&background=random`;
			} else {
				user.avatar = user.avatar ?? `https://ui-avatars.com/api/?name=${userData.first_name}+${userData.last_name}&background=random`;
			}

			return this.user = user;
		}
	},
});
